<template>
  <div class="p-grid">
    <template v-for="sectionKey in sectionKeys" :key="sectionKey">
      <div class="p-col-12">
        <span class="p-text-bold" style="fontSize: 1.2rem">{{
          sectionKey
        }}</span>
      </div>

      <template
        v-for="question in sections[sectionKey]"
        :key="`${sectionKey}${question}`"
      >
        <div class="p-col-12" v-if="question.type === QuestionItemType.text">
          <div class="p-grid">
            <div class="p-col-12 p-text-bold">
              {{ question.question }}
              <span v-if="question.required" style="color:red"> * </span>
              <span v-if="isInvalid(question)">
                <small class="p-error"
                  >กรุณาตอบแบบประเมินข้อนี้ ก่อนยืนยันผล</small
                >
              </span>
            </div>
            <div class="p-col-12 p-fluid">
              <Textarea
                v-model="question.answer"
                required
                :readonly="
                  (isEmployee && question.employee !== true) ||
                    (isSupervisor && question.supervisor !== true) ||
                    readonly
                "
              ></Textarea>
            </div>
          </div>
        </div>
        <div
          class="p-col-12"
          v-if="
            [QuestionItemType.scale, QuestionItemType.scaleWithMore].indexOf(
              question.type
            ) >= 0
          "
        >
          <div class="p-grid">
            <div class="p-col-12 p-text-bold">
              {{ question.question }}
              <span v-if="question.required" style="color:red"> * </span>
              <span v-if="isInvalid(question)">
                <small class="p-error"
                  >กรุณาตอบแบบประเมินข้อนี้ ก่อนยืนยันผล</small
                >
              </span>
            </div>
            <div class="p-col-12">
              <div class="p-grid">
                <div class="p-field-radiobutton p-lg-2">
                  <RadioButton
                    :id="`radio1${question.question}`"
                    :name="question.question"
                    value="5"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio1${question.question}`">มากที่สุด</label>
                </div>
                <div class="p-field-radiobutton p-lg-2">
                  <RadioButton
                    :id="`radio2${question.question}`"
                    :name="question.question"
                    value="4"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio2${question.question}`">มาก</label>
                </div>
                <div class="p-field-radiobutton p-lg-2">
                  <RadioButton
                    :id="`radio3${question.question}`"
                    :name="question.question"
                    value="3"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio3${question.question}`">ปานกลาง</label>
                </div>
                <div class="p-field-radiobutton p-lg-2">
                  <RadioButton
                    :id="`radio4${question.question}`"
                    :name="question.question"
                    value="2"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio4${question.question}`">น้อย</label>
                </div>
                <div class="p-field-radiobutton p-lg-2">
                  <RadioButton
                    :id="`radio5${question.question}`"
                    :name="question.question"
                    value="1"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio5${question.question}`">น้อยที่สุด </label>
                </div>
              </div>
            </div>
            <div
              class="p-col-12 p-fluid p-field"
              v-if="
                question.type === QuestionItemType.scaleWithMore &&
                  question.answer === '1'
              "
            >
              <label for="moreText">เพราะ</label>
              <Textarea
                id="moreText"
                v-model="question.more"
                required
                :readonly="
                  readonly ||
                    (isEmployee && question.employee !== true) ||
                    (isSupervisor && question.supervisor !== true)
                "
              ></Textarea>
            </div>
          </div>
        </div>
        <div class="p-col-12" v-if="question.type === QuestionItemType.choice">
          <div class="p-grid">
            <div class="p-col-12 p-text-bold">
              {{ question.question }}
              <span v-if="question.required" style="color:red"> * </span>
              <span v-if="isInvalid(question)">
                <small class="p-error"
                  >กรุณาตอบแบบประเมินข้อนี้ ก่อนยืนยันผล</small
                >
              </span>
            </div>
            <div class="p-col-12">
              <div class="p-grid">
                <div class="p-field-radiobutton p-col-6">
                  <RadioButton
                    :id="`radio1${question.question}`"
                    :name="question.question"
                    value="1"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio1${question.question}`">
                    ก. {{ question.choice1 }}</label
                  >
                </div>
                <div class="p-field-radiobutton p-col-6">
                  <RadioButton
                    :id="`radio2${question.question}`"
                    :name="question.question"
                    value="2"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio2${question.question}`">
                    ข. {{ question.choice2 }}</label
                  >
                </div>
                <div class="p-field-radiobutton p-col-6">
                  <RadioButton
                    :id="`radio3${question.question}`"
                    :name="question.question"
                    value="3"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio3${question.question}`">
                    ค. {{ question.choice3 }}</label
                  >
                </div>
                <div class="p-field-radiobutton p-col-6">
                  <RadioButton
                    :id="`radio4${question.question}`"
                    :name="question.question"
                    value="4"
                    v-model="question.answer"
                    required
                    :disabled="
                      readonly ||
                        (isEmployee && question.employee !== true) ||
                        (isSupervisor && question.supervisor !== true)
                    "
                  ></RadioButton>
                  <label :for="`radio4${question.question}`">
                    ง. {{ question.choice4 }}</label
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </template>
    <div
      class="p-col-12"
      v-if="isComplete"
      style="color: green; font-size: 1.3rem; font-weight: bold;"
    >
      ทำแบบประเมินครบถ้วนแล้ว
    </div>
    <div
      class="p-col-12"
      v-else
      style="color: red; font-size: 1.3rem; font-weight: bold;"
    >
      <li class="pi pi-ban"></li>
      กรุณาตอบแบบประเมินให้ครบถ้วนก่อน
    </div>
  </div>

  <div
    class="p-col-12"
    v-if="isAdmin()"
    style="font-size: 1.3rem; font-weight: bold"
  >
    คะแนนที่คำนวณได้คือ {{ (localFinalScore * 100).toFixed(2) }} %
  </div>
</template>

<script lang="ts">
import { QuestionItem, AssessmentItem, QuestionItemType } from "@/types";
import {
  PropType,
  defineComponent,
  computed,
  ref,
  watch,
  onMounted,
} from "vue";
import { usePlugin } from "@/plugins";
import { groupBy, sum } from "ramda";

export default defineComponent({
  name: "QuestionPanel",
  props: {
    questionItems: {
      required: true,
      type: Array as PropType<Array<QuestionItem>>,
    },
    assessmentItems: {
      type: Array as PropType<Array<AssessmentItem>>,
    },
    supervisorAssessmentItems: {
      type: Array as PropType<Array<AssessmentItem>>,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    isSupervisor: {
      type: Boolean,
      default: false,
    },
    isEmployee: {
      type: Boolean,
      default: false,
    },
    finalScore: {
      type: Number,
      required: false,
    },
    testMode: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    // const {} = usePlugin();
    const sections = computed(() =>
      groupBy((item) => {
        return item.section;
      }, localAssessmentItems.value)
    );
    const { isAdmin } = usePlugin();
    const sectionKeys = computed(() => Object.keys(sections.value));
    const localAssessmentItems = ref<AssessmentItem[]>([]);
    const localFinalScore = computed(() => {
      const rawScores = localAssessmentItems.value
        .filter(
          (x) =>
            (x.employee === true && props.isEmployee) ||
            (x.supervisor === true && props.isSupervisor) ||
            props.testMode
        )
        .map((x) => {
          if (x.finalScore !== true) return null;
          if (x.type === QuestionItemType.text) return null;
          if (
            x.type === QuestionItemType.scale ||
            x.type === QuestionItemType.scaleWithMore
          ) {
            return x.answer && x.answer.length > 0 ? parseInt(x.answer) / 5 : 0;
          }
          if (x.type === QuestionItemType.choice) {
            return parseInt(x.answer) === x.correctAnswer ? 1 : 0;
          }
          return 0;
        });
      const filtered = rawScores.filter((x) => x !== null) as number[];

      var total = filtered.length === 0 ? 0 : sum(filtered) / filtered.length;
      return Math.round(total * 100) / 100;
    });

    const isInvalid = (question: AssessmentItem) => {
      return (
        question.required &&
        !question.answer &&
        ((question.supervisor && props.isSupervisor) ||
          (question.employee && props.isEmployee) ||
          props.testMode)
      );
    };

    const isComplete = computed(() => {
      return (
        localAssessmentItems.value
          .map((x) => !isInvalid(x))
          .filter((x) => x === false).length === 0
      );
    });

    const onlyEmployee = computed(() => {
      return localAssessmentItems.value.findIndex((x) => x.supervisor) <= 0;
    });

    //In case load question item later.
    watch(
      () => props.questionItems,
      () => {
        if (
          props.assessmentItems == undefined ||
          props.assessmentItems.length === 0
        ) {
          localAssessmentItems.value = props.questionItems.map<AssessmentItem>(
            (x) => ({
              ...x,
              answer: "",
              more: "",
            })
          );
        }
      }
    );

    //In case load assesssment item later.
    watch(
      () => props.assessmentItems,
      () => {
        if (props.assessmentItems && props.assessmentItems.length > 0) {
          localAssessmentItems.value = props.assessmentItems;
        }
      }
    );

    //Auto emit output
    watch(
      () => localAssessmentItems.value,
      () => {
        emit("update:assessmentItems", localAssessmentItems.value);
        emit("update:finalScore", localFinalScore.value);
        emit("update:isComplete", isComplete.value);
        emit("update:onlyEmployee", onlyEmployee.value);
      },
      {
        deep: true,
      }
    );

    onMounted(() => {
      if (
        props.assessmentItems == undefined ||
        props.assessmentItems.length === 0
      ) {
        localAssessmentItems.value = props.questionItems.map<AssessmentItem>(
          (x) => ({
            ...x,
            answer: "",
            more: "",
          })
        );
      } else {
        localAssessmentItems.value = props.assessmentItems;
      }
    });

    return {
      sections,
      sectionKeys,
      QuestionItemType,
      localAssessmentItems,
      localFinalScore,
      isAdmin,
      isInvalid,
      isComplete,
    };
  },
});
</script>

<style></style>
